import { useStyletron } from 'baseui';

const useStyles = () => {
	const [css] = useStyletron();

	return {
		labelWithFilter: css({ display: 'flex', justifyContent: 'space-between', minWidth: '500px' }),
		labelText: css({ fontWeight: 'bold', padding: '12px 0px' }),
		jsonTextWrapper: css({ display: 'flex', flexDirection: 'column', gap: '5px' }),
		jsonTextPairWrapper: css({ display: 'flex', gap: '20px' }),
		copyImage: css({
			width: '20px',
			height: '20px'
		})
	};
};

export default useStyles;
